import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlanData } from "../../entry/server/app.ts";
import { appRepo } from "../../repo/app-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import PaginationView from "../../componrnts/pagination.tsx";
import { Pagination } from "../../lib/api.ts";

export default function PlansList() {
  const [plans, setPlans] = useState<PlanData[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const { setMessage } = useContext(AppContext);

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true);
      try {
        const response = await appRepo.getPlans(page);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست پلن‌ها ناموفق بود." });
          setPlans([]);
          return;
        }
        setPlans(response.data);
        setPagination(response.pagination || null);
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setPlans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [page, setMessage]);

  const onDeletePlan = async (id: number) => {
    if (!window.confirm("آیا از حذف این پلن مطمئن هستید؟")) {
      return;
    }

    try {
      const response = await appRepo.deletePlan(id);
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "حذف پلن با خطا مواجه شد." });
        return;
      }
      setPlans((prev) => prev.filter((item) => item.id !== id));
      setMessage({ type: "success", message: "پلن با موفقیت حذف شد." });
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    }
  };

  if (loading) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/plans/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد پلن
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          در حال دریافت لیست پلن‌ها...
        </div>
      </section>
    );
  }

  if (!plans.length) {
    return (
      <section className="mt-4 space-y-4">
        <div className="flex items-center justify-end">
          <Link
            to="/admin/plans/new"
            className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
          >
            ایجاد پلن
          </Link>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          هنوز هیچ پلنی ثبت نشده است.
        </div>
      </section>
    );
  }

  return (
    <section className="mt-4 space-y-4">
      <div className="flex items-center justify-end">
        <Link
          to="/admin/plans/new"
          className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          ایجاد پلن
        </Link>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
        <table className="min-w-full divide-y divide-slate-800 text-sm">
          <thead className="bg-slate-900/80">
            <tr>
              <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">نام پلن</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">قیمت</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">قیمت با تخفیف</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">مدت (روز)</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">فعال</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">ویژه</th>
              <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {plans.map((plan) => (
              <tr key={plan.id} className="transition hover:bg-slate-900">
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{plan.id}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-100">{plan.name}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{plan.price}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{plan.discount_price}</td>
                <td className="whitespace-nowrap px-4 py-3 text-slate-300">{plan.duration}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-3 py-1 text-xs font-medium ${plan.is_active ? "bg-emerald-500/20 text-emerald-300" : "bg-slate-700/60 text-slate-300"}`}>
                    {plan.is_active ? "فعال" : "غیرفعال"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-3 py-1 text-xs font-medium ${plan.is_featured ? "bg-indigo-500/20 text-indigo-300" : "bg-slate-700/60 text-slate-300"}`}>
                    {plan.is_featured ? "ویژه" : "عادی"}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <Link
                      to={`/admin/plans/${plan.id}/edit`}
                      className="inline-flex rounded-lg border border-slate-700 px-3 py-1.5 text-xs text-slate-200 transition hover:border-indigo-400 hover:text-indigo-300"
                    >
                      ویرایش
                    </Link>
                    <button
                      type="button"
                      onClick={() => onDeletePlan(plan.id)}
                      className="inline-flex rounded-lg border border-rose-700 px-3 py-1.5 text-xs text-rose-200 transition hover:border-rose-500 hover:text-rose-300"
                    >
                      حذف پلن
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pagination && <PaginationView pagination={pagination} onPageChange={setPage} />}
    </section>
  );
}
